import HelpOutline from "@mui/icons-material/HelpOutline";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from "@mui/material";
import type { FC } from "react";
import { useDialog } from "../../../../utils/hooks/use-dialog";

export const AnalyticsHelpButton: FC = () => {
  const { open, setOpen } = useDialog();

  return (
    <>
      <Button
        data-analytics-id="analytics-help-button"
        onClick={() => setOpen(true)}
        variant="contained"
        startIcon={<HelpOutline />}
        color="inherit"
        sx={{
          width: "fit-content",
          borderRadius: 999,
          color: "text.secondary",
          fontWeight: 400,
        }}
      >
        Something not adding up?
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>About analytics</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Spam filters, ad blockers, and virus scanners can cause discrepancies between your open
            and interaction rates. We do our best to filter this out, but sometimes your open and
            interaction rates might not add up.
          </Typography>
          <Link
            href="https://help.changeengine.com/why-can-interaction-rates-exceed-100"
            target="_blank"
          >
            <Typography variant="body1" sx={{ mt: 2 }}>
              See our help article.
            </Typography>
          </Link>
        </DialogContent>
        <DialogActions>
          <Button
            data-analytics-id="acknowledge-analytics-help"
            onClick={() => setOpen(false)}
            color="primary"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
